import * as L from 'leaflet';

import { checkTooltips } from './checkTooltips';
import { mapOptions, resetMapBtn } from '../options';

/**
 * Reset map to initial state (popups, center, zoom)
 *
 * @param {*} map
 */
export function resetMap(map) {
    checkTooltips(map);

    map.closePopup();
    map.setView(
        new L.latLng(mapOptions.center[0], mapOptions.center[1]),
        mapOptions.zoom
    );

    resetMapBtn.disabled = true;
}
